import { createEffect, createEvent, createStore, sample } from 'effector';
import { DiContainer } from '@@/di/di-container';
import { AgricultureService } from '@@/agriculture/services/agriculture.service';
import { IAgriculture } from '@@/agriculture/ts';
import { IBag } from '@/modules/bags/ts';

const agricultureService = DiContainer.get(AgricultureService);

export const loadAndSetAgriculture = createEvent();

export const closeAgricultureModal = createEvent();

export const markFilledSleeve = createEvent();

markFilledSleeve.watch((data) => {
  console.log('mark filled sleeve', data);
});

export const copyAgricultureModal = createEvent<{ bagId: string } | null>();

export const copySleeveParams = createEvent<{ bag: IBag } | null>();

export const editAgricultureModal = createEvent<{
  id: string;
  coords?: number[];
  status?: boolean;
}>();

export const showFillModal = createEvent<{
  id: string;
  coords: number[];
}>();

export const loadAgricultureFx = createEffect(() =>
  agricultureService.getAndSaveCulturesToStorage(),
);
export const loadAgricultureFromStorageFx = createEffect(() =>
  agricultureService.getCulturesFromStorage(),
);
sample({
  clock: loadAndSetAgriculture,
  target: [loadAgricultureFromStorageFx, loadAgricultureFx],
});

export const $agriculture = createStore<Array<IAgriculture>>([]);
sample({
  clock: [loadAgricultureFromStorageFx.doneData, loadAgricultureFx.doneData],
  filter: Array.isArray,
  target: $agriculture,
});

export const $agricultureIsLoading = loadAgricultureFx.pending;
export const $agricultureById = $agriculture.map((state) =>
  state.reduce(
    (acc, item) => ({ ...acc, [item.id]: item }),
    {} as Record<number, IAgriculture>,
  ),
);

export const $copyBagModalEnable = createStore<string | null>(null).on(
  copyAgricultureModal,
  (_, value) => value?.bagId || null,
);

//TODO этот стор используется для отображения модалки заполнения и редактирования. Перенести модалку в раздел с контекстным меню необходимо, чтобы избавиться от стора
export const $agricultureModalIdEnable = createStore<[string | null, boolean]>([
  null,
  false,
])
  .on(showFillModal, (_, { id }) => {
    return [id, false];
  })
  .on(closeAgricultureModal, () => {
    return ['', false];
  })
  .on(editAgricultureModal, (_, { id }) => {
    return [id, true];
  });


  export const $copiedBagParamsBuffer = createStore<IBag | null>(null).on(copySleeveParams, (state, payload) => {
    return payload?.bag || null;
  })
